export default class BaseRenderer {
  /* override in subclasses */
  render(widget, ctx) {
    throw new Error("render() must be implemented");
  }
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/renderers/BaseRenderer.js